import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreamByRequestUid,
} from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import React from 'react';
import { PerfVsIndexCapsuleConfigState } from './store/config/PerfVsIndexCapsuleConfigState';
import { buildPerfVsIndexCapsuleConfigSlice } from './store/config/configslice';
import { FillsGraphByOrderIdOrSymQtyStreamRequestWithSymQty } from 'communication/types/fillsGraph/FillsGraphByOrderIdOrSymQtyStreamRequest';
import { perfVsIndexCapsuleStreamConfig } from './store/stream-config';
import { perfVsIndexCapsuleDescription } from './components/description/perfVsIndexCapsuleDescription';
import { PerfVsIndexCapsule } from './components/PerfVsIndexCapsule';
import { fillsGraphWidgetStrategy } from 'widgets/fillsGraph/FillsGraphWidgetStrategy';
import { PerfVsIndexCapsuleMyPortfolioCapsuleContent } from './components/PerfVsIndexCapsuleMyPortfolioCapsuleContent';
import PerfVsIndexCapsuleSettings from 'widgets/perfVsIndexCapsule/components/settings/PerfVsIndexCapsuleSettings';
import { usePerfVsIndexCapsuleMessagesInMyPortfolioCapsules } from 'widgets/perfVsIndexCapsule/components/usePerfVsIndexCapsuleMessagesInMyPortfolioCapsules';
import { PerfVsIndexCapsuleMyPortfolioCapsuleTitle } from 'widgets/perfVsIndexCapsule/components/PerfVsIndexCapsuleMyPortfolioCapsuleTitle';

const { initialConfigState } = buildPerfVsIndexCapsuleConfigSlice();

const useMessagesInMyPortfolioCapsules = (symbol: string) =>
    usePerfVsIndexCapsuleMessagesInMyPortfolioCapsules(symbol);

export const perfVsIndexCapsuleWidgetStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<PerfVsIndexCapsuleConfigState> &
    WidgetStrategyWithConfig<PerfVsIndexCapsuleConfigState> &
    WidgetStrategyWithStreamByRequestUid<FillsGraphByOrderIdOrSymQtyStreamRequestWithSymQty> =
    {
        title: 'Performance Vs Index',
        supportedHosts: ['tile'],
        reactComponentType: PerfVsIndexCapsule,
        getRequiredOrderColumns:
            fillsGraphWidgetStrategy.getRequiredOrderColumns,
        categories: [WidgetCategory.PRICE_CAPSULES],
        description: perfVsIndexCapsuleDescription,
        managedStreamConfig: perfVsIndexCapsuleStreamConfig,
        portfolioSelectionRequirements:
            PortfolioSelectionRequirements.SingleSymbolQuantity,
        initialConfigState,
        supportsMyPortfolioCapsule: true,
        supportsMyPortfolioCapsuleConfig: true,
        myPortfolioCapsuleContentReactComponentType:
            PerfVsIndexCapsuleMyPortfolioCapsuleContent,
        myPortfolioCapsuleTitleReactComponentType:
            PerfVsIndexCapsuleMyPortfolioCapsuleTitle,
        renderSettingsBody,
        useMessagesInMyPortfolioCapsules,
    };

function renderSettingsBody(
    config: PerfVsIndexCapsuleConfigState,
    onChange: (configDelta: Partial<PerfVsIndexCapsuleConfigState>) => void
) {
    return <PerfVsIndexCapsuleSettings config={config} onChange={onChange} />;
}
